<template>
    <div :class="baseerp+'div'">
        <div class="el-dialog__header title">
            应收账款
            <i class="el-icon-close" @click="close"></i>
        </div>
        <div class="p-5-9">
            <el-input class="mr9" v-model="search" placeholder="请输入编号/品名" size="mini" clearable  @change="searchFun">
                <el-button  slot="append" icon="el-icon-search"  size="mini" @click="searchFun" ></el-button>
            </el-input>
            <div  :style="{height: tableHeight+'px',overflowY: 'auto',paddingTop:'6px'}">
                <div class="boxborder" v-for="(item,index) in ysList">
                    <div class="font-weight">{{item.vc_no}}<span :class="['dib pl5 ',baseerp+'color']">{{'['+item.vc_type+']'}}</span></div>
                    <div>
                        <span class="lable">品名</span><span class="value">{{item.vc_pname}}</span>
                    </div>
                    <div>
                        <span class="lable">库号</span><span class="value ">{{item.vc_kno}}</span>
                    </div>
                    <div class="dfjc">
                        <span class="lable">已到账/应收</span><span class="value font-weight">{{item.vc_ename+' '+item.i_received+'/'+item.i_except}}</span>
                    </div>
                </div>
            </div>
            <div class="topBorder dfjc">
                <span class="lable">合计:</span><span class="value font-weight">{{this.ydzSum+'/'+this.yszeSum}}</span>
            </div>
        </div>

    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";

    export default {
        name: "YsList",
        props:{
            data:{
                type: Object,
                required:true,
            }
        },
        components: {},
        data() {
            return {
                baseerp:'',
                ysList:[],
                ydzSum:0,
                yszeSum:0,
                search:'',
                tableHeight:0,
            }
        },
        watch: {
            data: {
                handler() {
                    this.ysList=[]
                    this.getAccountsReceivable()
                },
                immediate:true,
                deep:true
            },
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },

        activated(){
            this.onResize();
        },
        mounted() {
            this.getAccountsReceivable()
            this.baseerp=baseerp
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-178

            },
            close(){
                this.$emit('close')
            },
            searchFun(){
                this.getAccountsReceivable()
            },
            async getAccountsReceivable(){
                let param={
                    i_gsid:this.data.i_gsid,
                    i_khid:this.data.i_khid,
                    vc_search:this.search
                };
                let res=await API.getAccountsReceivable(param);
                if ( res.code == 1 ){
                    this.ysList=res.data;
                    if(this.ysList.length>0){
                        this.ydzSum= this.ysList.reduce(function(acc,obj){
                           return acc+obj.i_received
                            },0);
                        this.ydzSum=Math.round(this.ydzSum*100)/100
                        this.yszeSum= this.ysList.reduce(function(acc,obj){
                            return acc+obj.i_except
                        },0)
                        this.yszeSum=Math.round(this.yszeSum*100)/100
                    }

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    div{
        font-size: 12px;
    }
    .title{
        color: white;
        display: flex;
        justify-content:space-between;
        padding: 10px 9px !important;
        align-items: center;
        font-size: 14px;

    }
    .ghwdiv{
        .title{
            background-color: var(--lightghw);
        }

    }
    .havaydiv{
        .title{
            background-color: var(--lighthavay);
        }

    }
    .dib{
        display: inline-block;
    }
    .pl5{
        padding-left: 5px;
    }
    .p-5-9{
        padding: 5px 9px;
    }
    .lable{
        color: #9e9e9e;
        display: inline-block;
        padding-right: 9px;
    }
    .value{
        display: inline-block;
    }
    .dfjc{
        display: flex;
        justify-content: space-between;
    }
    .boxborder{
        border: 1px solid #DCDFE6;
        padding: 5px 9px;
        margin-top: 3px;
        margin-bottom: 3px;
border-radius: 5px;
    }
    .topBorder{
        padding-top: 5px;
        margin-top: 5px;
        font-size: 14px;

        border-top: 1px solid #DCDFE6;

    }
    .font-weight{
        font-weight: bold;
        font-size: 14px;

    }
</style>